<app-project-control-rate-list></app-project-control-rate-list>